import { mehirApi as api } from '../api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllCodes: build.query<GetAllCodesApiResponse, GetAllCodesApiArg>({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/codes`,
        params: {
          CampaignId: queryArg.campaignId,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getAllCategoriesBackoffice: build.query<
      GetAllCategoriesBackofficeApiResponse,
      GetAllCategoriesBackofficeApiArg
    >({
      query: () => ({ url: `/campaignservice/v1/Backoffice/categories` }),
    }),
    createCategory: build.mutation<
      CreateCategoryApiResponse,
      CreateCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/categories`,
        method: 'POST',
        body: queryArg.createCategoryRequest,
      }),
    }),
    updateCategory: build.mutation<
      UpdateCategoryApiResponse,
      UpdateCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/categories/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateCategoryRequest,
      }),
    }),
    deleteCategory: build.mutation<
      DeleteCategoryApiResponse,
      DeleteCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/categories/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getAllCampaigns: build.query<
      GetAllCampaignsApiResponse,
      GetAllCampaignsApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/campaigns`,
        params: {
          CategoryId: queryArg.categoryId,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getCampaignById: build.query<
      GetCampaignByIdApiResponse,
      GetCampaignByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/backoffice/campaigns/${queryArg.id}`,
      }),
    }),
    getStats: build.query<GetStatsApiResponse, GetStatsApiArg>({
      query: () => ({
        url: `/campaignservice/v1/Backoffice/backoffice/campaigns/stats`,
      }),
    }),
    updateCampaign: build.mutation<
      UpdateCampaignApiResponse,
      UpdateCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/${queryArg.campaignId}`,
        method: 'PUT',
        body: queryArg.campaignUpdateRequest,
      }),
    }),
    deleteCampaign: build.mutation<
      DeleteCampaignApiResponse,
      DeleteCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/${queryArg.campaignId}`,
        method: 'DELETE',
      }),
    }),
    downloadTemplate: build.query<
      DownloadTemplateApiResponse,
      DownloadTemplateApiArg
    >({
      query: () => ({
        url: `/campaignservice/v1/Backoffice/import-codes/template`,
      }),
    }),
    importCodes: build.mutation<ImportCodesApiResponse, ImportCodesApiArg>({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/import-codes`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    generateCodes: build.mutation<
      GenerateCodesApiResponse,
      GenerateCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/generate-codes`,
        method: 'POST',
        body: queryArg.generateCampaignCodesRequest,
      }),
    }),
    createCampaign: build.mutation<
      CreateCampaignApiResponse,
      CreateCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice`,
        method: 'POST',
        body: queryArg.campaignCreateRequest,
      }),
    }),
    updateBrand: build.mutation<UpdateBrandApiResponse, UpdateBrandApiArg>({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/brands/${queryArg.brandId}`,
        method: 'PUT',
        body: queryArg.brandUpdateRequest,
      }),
    }),
    getBrand: build.query<GetBrandApiResponse, GetBrandApiArg>({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/brands/${queryArg.brandId}`,
      }),
    }),
    deleteBrand: build.mutation<DeleteBrandApiResponse, DeleteBrandApiArg>({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/brands/${queryArg.brandId}`,
        method: 'DELETE',
      }),
    }),
    listBrandsForBackoffice: build.query<
      ListBrandsForBackofficeApiResponse,
      ListBrandsForBackofficeApiArg
    >({
      query: () => ({ url: `/campaignservice/v1/Backoffice/brands/manage` }),
    }),
    listAllBrands: build.query<ListAllBrandsApiResponse, ListAllBrandsApiArg>({
      query: () => ({ url: `/campaignservice/v1/Backoffice/brands` }),
    }),
    createBrand: build.mutation<CreateBrandApiResponse, CreateBrandApiArg>({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/brands`,
        method: 'POST',
        body: queryArg.brandCreateRequest,
      }),
    }),
    getBrandForBackoffice: build.query<
      GetBrandForBackofficeApiResponse,
      GetBrandForBackofficeApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Backoffice/brands/manage/${queryArg.brandId}`,
      }),
    }),
    listAllCampaigns: build.query<
      ListAllCampaignsApiResponse,
      ListAllCampaignsApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Campaigns`,
        params: {
          Search: queryArg.search,
          Cursor: queryArg.cursor,
          Limit: queryArg.limit,
        },
      }),
    }),
    listCampaignsByCategory: build.query<
      ListCampaignsByCategoryApiResponse,
      ListCampaignsByCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Campaigns/category/${queryArg.categoryId}`,
        params: {
          Search: queryArg.search,
          Cursor: queryArg.cursor,
          Limit: queryArg.limit,
        },
      }),
    }),
    getAllImageUrls: build.query<
      GetAllImageUrlsApiResponse,
      GetAllImageUrlsApiArg
    >({
      query: () => ({ url: `/campaignservice/v1/Campaigns/image-urls` }),
    }),
    getCampaign: build.query<GetCampaignApiResponse, GetCampaignApiArg>({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Campaigns/${queryArg.campaignId}`,
      }),
    }),
    generateShareLinks: build.mutation<
      GenerateShareLinksApiResponse,
      GenerateShareLinksApiArg
    >({
      query: () => ({
        url: `/campaignservice/v1/Campaigns/generate-share-links`,
        method: 'POST',
      }),
    }),
    generateCode: build.mutation<GenerateCodeApiResponse, GenerateCodeApiArg>({
      query: (queryArg) => ({
        url: `/campaignservice/v1/Campaigns/Generate`,
        method: 'POST',
        body: queryArg.generateCodeRequest,
      }),
    }),
    getAllCategories: build.query<
      GetAllCategoriesApiResponse,
      GetAllCategoriesApiArg
    >({
      query: () => ({ url: `/campaignservice/v1/Categories` }),
    }),
    removeFavoriteCampaign: build.mutation<
      RemoveFavoriteCampaignApiResponse,
      RemoveFavoriteCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/FavoriteCampaigns/${queryArg.campaignId}`,
        method: 'DELETE',
      }),
    }),
    addFavoriteCampaign: build.mutation<
      AddFavoriteCampaignApiResponse,
      AddFavoriteCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/FavoriteCampaigns/${queryArg.campaignId}`,
        method: 'POST',
      }),
    }),
    getFavoriteCampaignsByUserId: build.query<
      GetFavoriteCampaignsByUserIdApiResponse,
      GetFavoriteCampaignsByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/campaignservice/v1/FavoriteCampaigns`,
        params: {
          Search: queryArg.search,
          Cursor: queryArg.cursor,
          Limit: queryArg.limit,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as fitApi };
export type GetAllCodesApiResponse =
  /** status 200 OK */ CodeBackofficeDtoPaginationResponseRead;
export type GetAllCodesApiArg = {
  campaignId?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetAllCategoriesBackofficeApiResponse =
  /** status 200 OK */ CategoryViewModelRead[];
export type GetAllCategoriesBackofficeApiArg = void;
export type CreateCategoryApiResponse =
  /** status 201 Created */ CategoryIdRead;
export type CreateCategoryApiArg = {
  createCategoryRequest: CreateCategoryRequest;
};
export type UpdateCategoryApiResponse = unknown;
export type UpdateCategoryApiArg = {
  id: string;
  updateCategoryRequest: UpdateCategoryRequest;
};
export type DeleteCategoryApiResponse = unknown;
export type DeleteCategoryApiArg = {
  id: string;
};
export type GetAllCampaignsApiResponse =
  /** status 200 OK */ CampaignReadModelPaginationResponseRead;
export type GetAllCampaignsApiArg = {
  categoryId?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetCampaignByIdApiResponse =
  /** status 200 OK */ CampaignReadModelRead;
export type GetCampaignByIdApiArg = {
  id: string;
};
export type GetStatsApiResponse = /** status 200 OK */ CampaignStatsViewModel;
export type GetStatsApiArg = void;
export type UpdateCampaignApiResponse = /** status 200 OK */ string;
export type UpdateCampaignApiArg = {
  campaignId: string;
  campaignUpdateRequest: CampaignUpdateRequest;
};
export type DeleteCampaignApiResponse = unknown;
export type DeleteCampaignApiArg = {
  campaignId: string;
};
export type DownloadTemplateApiResponse = unknown;
export type DownloadTemplateApiArg = void;
export type ImportCodesApiResponse = unknown;
export type ImportCodesApiArg = {
  body: {
    file: Blob;
  };
};
export type GenerateCodesApiResponse =
  /** status 200 OK */ GenerateCampaignCodesResult;
export type GenerateCodesApiArg = {
  generateCampaignCodesRequest: GenerateCampaignCodesRequest;
};
export type CreateCampaignApiResponse = /** status 201 Created */ string;
export type CreateCampaignApiArg = {
  campaignCreateRequest: CampaignCreateRequest;
};
export type UpdateBrandApiResponse = /** status 200 OK */ string;
export type UpdateBrandApiArg = {
  brandId: string;
  brandUpdateRequest: BrandUpdateRequest;
};
export type GetBrandApiResponse = /** status 200 OK */ BrandViewModel;
export type GetBrandApiArg = {
  brandId: string;
};
export type DeleteBrandApiResponse = unknown;
export type DeleteBrandApiArg = {
  brandId: string;
};
export type ListBrandsForBackofficeApiResponse =
  /** status 200 OK */ BrandViewModel[];
export type ListBrandsForBackofficeApiArg = void;
export type ListAllBrandsApiResponse = /** status 200 OK */ BrandViewModel[];
export type ListAllBrandsApiArg = void;
export type CreateBrandApiResponse = /** status 201 Created */ string;
export type CreateBrandApiArg = {
  brandCreateRequest: BrandCreateRequest;
};
export type GetBrandForBackofficeApiResponse =
  /** status 200 OK */ BrandViewModel;
export type GetBrandForBackofficeApiArg = {
  brandId: string;
};
export type ListAllCampaignsApiResponse =
  /** status 200 OK */ CampaignViewModelGuidCursorPaginationResponseRead;
export type ListAllCampaignsApiArg = {
  search?: string;
  cursor: string;
  limit: number;
};
export type ListCampaignsByCategoryApiResponse =
  /** status 200 OK */ CampaignViewModelGuidCursorPaginationResponseRead;
export type ListCampaignsByCategoryApiArg = {
  categoryId: string;
  search?: string;
  cursor: string;
  limit: number;
};
export type GetAllImageUrlsApiResponse = /** status 200 OK */ string[];
export type GetAllImageUrlsApiArg = void;
export type GetCampaignApiResponse = /** status 200 OK */ CampaignViewModelRead;
export type GetCampaignApiArg = {
  campaignId: string;
};
export type GenerateShareLinksApiResponse =
  /** status 200 OK */ GenerateShareLinksResponse;
export type GenerateShareLinksApiArg = void;
export type GenerateCodeApiResponse = /** status 200 OK */ CodeViewModel;
export type GenerateCodeApiArg = {
  generateCodeRequest: GenerateCodeRequest;
};
export type GetAllCategoriesApiResponse =
  /** status 200 OK */ CategoryViewModelRead[];
export type GetAllCategoriesApiArg = void;
export type RemoveFavoriteCampaignApiResponse = unknown;
export type RemoveFavoriteCampaignApiArg = {
  campaignId: string;
};
export type AddFavoriteCampaignApiResponse = /** status 200 OK */ string;
export type AddFavoriteCampaignApiArg = {
  campaignId: string;
};
export type GetFavoriteCampaignsByUserIdApiResponse =
  /** status 200 OK */ FavoriteCampaignViewModelGuidCursorPaginationResponseRead;
export type GetFavoriteCampaignsByUserIdApiArg = {
  search?: string;
  cursor: string;
  limit: number;
};
export type CodeBackofficeDto = {
  id?: string;
  codeValue?: string | null;
  expireDate?: string;
  campaignId?: string;
  campaignName?: string | null;
  usedDate?: string | null;
  userId?: string | null;
  isUsed?: boolean;
  description?: string | null;
  createdAt?: string;
};
export type CodeBackofficeDtoPaginationResponse = {
  items?: CodeBackofficeDto[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type CodeBackofficeDtoPaginationResponseRead = {
  items?: CodeBackofficeDto[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type ErrorType =
  | 'failure'
  | 'unexpected'
  | 'validation'
  | 'conflict'
  | 'not_found'
  | 'unauthorized'
  | 'forbidden'
  | 'unknown';
export type Error = {
  type?: ErrorType;
};
export type ErrorRead = {
  code?: string | null;
  description?: string | null;
  type?: ErrorType;
  numericType?: number;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type EnhancedProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Error[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type EnhancedProblemDetailsRead = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: ErrorRead[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type CategoryIcon = {};
export type CategoryIconRead = {
  iconName?: string | null;
  color?: string | null;
  color2?: string | null;
  iconSize?: string | null;
};
export type CategoryViewModel = {
  key?: string;
  title?: string | null;
  icon?: CategoryIcon;
  isFeatured?: boolean;
  count?: number;
};
export type CategoryViewModelRead = {
  key?: string;
  title?: string | null;
  icon?: CategoryIconRead;
  isFeatured?: boolean;
  count?: number;
};
export type CategoryId = {};
export type CategoryIdRead = {
  value?: string;
};
export type CreateCategoryRequest = {
  name?: string | null;
  iconName?: string | null;
  iconColor?: string | null;
  iconColor2?: string | null;
  iconSize?: string | null;
  isFeatured?: boolean;
};
export type UpdateCategoryRequest = {
  name?: string | null;
  iconName?: string | null;
  iconColor?: string | null;
  iconColor2?: string | null;
  iconSize?: string | null;
  isFeatured?: boolean;
};
export type CategoryReadModel = {
  id?: string;
  name?: string | null;
  icon?: CategoryIcon;
  isFeatured?: boolean;
  createdAt?: string;
  updatedAt?: string | null;
  isDeleted?: boolean;
  campaigns?: CampaignReadModel[] | null;
};
export type CategoryReadModelRead = {
  id?: string;
  name?: string | null;
  icon?: CategoryIconRead;
  isFeatured?: boolean;
  createdAt?: string;
  updatedAt?: string | null;
  isDeleted?: boolean;
  campaigns?: CampaignReadModel[] | null;
};
export type BrandReadModel = {
  id?: string;
  name?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type CampaignReadModel = {
  id?: string;
  name?: string | null;
  description?: string | null;
  webPage?: string | null;
  imageUrl?: string | null;
  categoryId?: string;
  brandId?: string;
  isHighlighted?: boolean;
  category?: CategoryReadModel;
  brand?: BrandReadModel;
  createdAt?: string;
  isDeleted?: boolean;
  shareLink?: string | null;
};
export type CampaignReadModelRead = {
  id?: string;
  name?: string | null;
  description?: string | null;
  webPage?: string | null;
  imageUrl?: string | null;
  categoryId?: string;
  brandId?: string;
  isHighlighted?: boolean;
  category?: CategoryReadModelRead;
  brand?: BrandReadModel;
  createdAt?: string;
  isDeleted?: boolean;
  shareLink?: string | null;
};
export type CampaignReadModelPaginationResponse = {
  items?: CampaignReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type CampaignReadModelPaginationResponseRead = {
  items?: CampaignReadModelRead[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type CampaignStatsViewModel = {
  totalCampaigns?: number;
  activeCampaigns?: number;
  highlightedCampaigns?: number;
  totalCodes?: number;
  usedCodes?: number;
  availableCodes?: number;
};
export type CampaignUpdateRequest = {
  name?: string | null;
  description?: string | null;
  webPage?: string | null;
  categoryId?: string;
  brandId?: string;
  imageUrl?: string | null;
  isHighlighted?: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type GenerateCampaignCodesResult = {
  generatedCount?: number;
};
export type GenerateCampaignCodeItemRequest = {
  campaignId?: string;
  code?: string | null;
  quantity?: number;
  expireDate?: string;
  description?: string | null;
};
export type GenerateCampaignCodesRequest = {
  items?: GenerateCampaignCodeItemRequest[] | null;
};
export type CampaignCreateRequest = {
  name?: string | null;
  description?: string | null;
  webPage?: string | null;
  categoryId?: string;
  brandId?: string;
  imageUrl?: string | null;
  isHighlighted?: boolean;
};
export type BrandUpdateRequest = {
  name?: string | null;
};
export type BrandViewModel = {
  id?: string;
  name?: string | null;
  createdAt?: string;
};
export type BrandCreateRequest = {
  name?: string | null;
};
export type CampaignViewModel = {
  id?: string;
  title?: string | null;
  description?: string | null;
  webPage?: string | null;
  image?: string | null;
  categoryId?: string;
  brandId?: string;
  isHighlighted?: boolean;
  category?: CategoryViewModel;
  brand?: BrandViewModel;
  createdAt?: string;
  shareLink?: string | null;
  isFavorite?: boolean;
};
export type CampaignViewModelRead = {
  id?: string;
  title?: string | null;
  description?: string | null;
  webPage?: string | null;
  image?: string | null;
  categoryId?: string;
  brandId?: string;
  isHighlighted?: boolean;
  category?: CategoryViewModelRead;
  brand?: BrandViewModel;
  createdAt?: string;
  shareLink?: string | null;
  isFavorite?: boolean;
};
export type CampaignViewModelGuidCursorPaginationResponse = {
  items?: CampaignViewModel[] | null;
  cursor?: string;
  hasMore?: boolean;
};
export type CampaignViewModelGuidCursorPaginationResponseRead = {
  items?: CampaignViewModelRead[] | null;
  cursor?: string;
  hasMore?: boolean;
};
export type GenerateShareLinksResponse = {
  totalCampaigns?: number;
  successCount?: number;
  failureCount?: number;
  failedCampaignIds?: string[] | null;
};
export type CodeViewModel = {
  id?: string;
  code?: string | null;
  expireDate?: string;
  description?: string | null;
};
export type GenerateCodeRequest = {
  campaignId?: string;
};
export type FavoriteCampaignViewModel = {
  userId?: string | null;
  campaigns?: CampaignViewModel[] | null;
};
export type FavoriteCampaignViewModelRead = {
  userId?: string | null;
  campaigns?: CampaignViewModelRead[] | null;
};
export type FavoriteCampaignViewModelGuidCursorPaginationResponse = {
  items?: FavoriteCampaignViewModel[] | null;
  cursor?: string;
  hasMore?: boolean;
};
export type FavoriteCampaignViewModelGuidCursorPaginationResponseRead = {
  items?: FavoriteCampaignViewModelRead[] | null;
  cursor?: string;
  hasMore?: boolean;
};
export const {
  useGetAllCodesQuery,
  useGetAllCategoriesBackofficeQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetAllCampaignsQuery,
  useGetCampaignByIdQuery,
  useGetStatsQuery,
  useUpdateCampaignMutation,
  useDeleteCampaignMutation,
  useDownloadTemplateQuery,
  useImportCodesMutation,
  useGenerateCodesMutation,
  useCreateCampaignMutation,
  useUpdateBrandMutation,
  useGetBrandQuery,
  useDeleteBrandMutation,
  useListBrandsForBackofficeQuery,
  useListAllBrandsQuery,
  useCreateBrandMutation,
  useGetBrandForBackofficeQuery,
  useListAllCampaignsQuery,
  useListCampaignsByCategoryQuery,
  useGetAllImageUrlsQuery,
  useGetCampaignQuery,
  useGenerateShareLinksMutation,
  useGenerateCodeMutation,
  useGetAllCategoriesQuery,
  useRemoveFavoriteCampaignMutation,
  useAddFavoriteCampaignMutation,
  useGetFavoriteCampaignsByUserIdQuery,
} = injectedRtkApi;
